// import React, { useState, useEffect } from "react";
// import "./postrepairprocess.css";
// import { useParams } from "react-router";
// import axios from "axios";

// const initialImages = [
//   { id: 1, name: "Image_1", date: "", url: null },
//   { id: 2, name: "Image_2", date: "", url: null },
//   { id: 3, name: "Image_3", date: "", url: null },
// ];

// const RepairProcess = () => {
//   const { claimNumber } = useParams();
//   const [images, setImages] = useState(initialImages);
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [previewUrl, setPreviewUrl] = useState(null);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   const upload = `${process.env.PUBLIC_URL}/claim-landing/upload.png`;
//   const preview = `${process.env.PUBLIC_URL}/preview.png`;
//   const repair = `${process.env.PUBLIC_URL}/repairandpostrepair.png`;

//   const azureBaseUrl = 'https://caisdatahouse.blob.core.windows.net/insurance-inspection/';
//   const sasToken = 'sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D';
//   const tryBlobExtensions = async (baseName) => {
//     const extensions = ['jpg', 'jpeg'];
//     for (let ext of extensions) {
//       const blobName = `${baseName}.${ext}`;
//       try {
//         const response = await axios.post("/process_data/check_document_exists", { blobName });
//         if (response.data.exists) {
//           const imageUrl = `${azureBaseUrl}${blobName}?${sasToken}`;
//           return { blobName, url: imageUrl };
//         }
//       } catch (err) {
//         console.error(`Error checking ${blobName}:`, err.message);
//       }
//     }
//     return null;
//   };


//   useEffect(() => {
//     const checkImagesExist = async () => {
//       const updatedImages = await Promise.all(
//         initialImages.map(async (img) => {
//           const baseBlobName = `Pre-repair-images/${claimNumber}_pre_${img.name}`;
//           const result = await tryBlobExtensions(baseBlobName);
//           if (result) {
//             return {
//               ...img,
//               url: result.url,
//               date: new Date().toLocaleString(),
//             };
//           }
//           return img;
//         })
//       );
//       setImages(updatedImages);
//     };

//     checkImagesExist();
//   }, [claimNumber]);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const handleUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();

//     reader.onloadend = async () => {
//       try {
//         const base64StringWithPrefix = reader.result; // e.g., data:image/jpeg;base64,...
//         const base64String = base64StringWithPrefix.split(",")[1]; // remove prefix

//         const updatedImages = [...images];
//         const currentDateTime = new Date().toLocaleString();
//         const docId = images[currentImageIndex].name;
//         const ext = file.name.split(".").pop();
//         const blobName = `Pre-repair-images/${claimNumber}_pre_${docId}.${ext}`;
//         const contentType = file.type;

//         console.log("Sending to backend:", { blobName, contentType });

//         // ✅ Send to backend to upload to Azure
//         const response = await axios.post('/process_data/upload-file', {
//           blobName,
//           fileContent: base64String,
//           contentType,
//         });

//         if (response.data.message === "Upload successful") {
//           const uploadedUrl = `https://caisdatahouse.blob.core.windows.net/insurance-inspection/${blobName}?${sasToken}`;

//           updatedImages[currentImageIndex].url = uploadedUrl;
//           updatedImages[currentImageIndex].date = currentDateTime;

//           setImages(updatedImages);
//           console.log("97", images);
//           // ✅ Call to update claim progress in DB
//           await axios.post('/process_data/update_pre_repair_upload', {
//             claimNumber,
//           });
//           if (currentImageIndex < images.length - 1) {
//             setCurrentImageIndex(currentImageIndex + 1);
//           }
//         } else {
//           throw new Error("Upload failed at backend.");
//         }

//       } catch (error) {
//         console.error("Upload to backend failed:", error);
//         alert("Failed to upload image.");
//       }
//     };

//     reader.readAsDataURL(file);
//   };

//   return (
//     <div>
//       {/* Post Repair Section */}
//       <div className="post-repair-card">
//         <div className="header">
//           <h2>Repair Process</h2>
//           <img
//             src={repair}
//             alt="Preview"
//             className="icon-img"
//             style={{ width: "24px", height: "24px" }}
//           />
//         </div>

//         {/* Mobile Camera Upload */}
//         <div className="image-box">
//           <label className={`camera-label ${!isMobile ? "disabled" : ""}`}>
//             <input
//               type="file"
//               accept="image/*"
//               capture="environment"
//               style={{ display: "none" }}
//               onChange={handleUpload}
//               disabled={!isMobile}
//             />
//             <div className={`camera-trigger ${!isMobile ? "disabled" : ""}`}>
//               <img
//                 src="https://icons.iconarchive.com/icons/iconsmind/outline/512/Camera-2-icon.png"
//                 alt="camera"
//                 className="camera-icon"
//               />
//               <p>Open Camera</p>
//             </div>
//           </label>
//         </div>
//       </div>

//       {/* Post Repair Images Section */}
//       <div className="card">
//         <h3 className="title">Repair Process Images</h3>
//         <div className="image-list">
//           {images.map((image) => (


//             <div key={image.id} className="image-card">
//               <div className="image-content">
//                 <div className="text-info">
//                   <p className="image-name">{image.name}</p>
//                   {image.date && <p className="image-date">{image.date}</p>}
//                 </div>
//                 {/* {image.url ? (
//                   <button
//                     className="preview-button"
//                     onClick={() => setPreviewUrl(image.url)}
//                   >
//                     <img
//                       src={image.url}
//                       alt="Preview"
//                       className="icon-img"
//                       style={{ width: "15px", height: "15px" }}
//                     />
//                     <span>Preview</span>
//                   </button>
//                 ) : (
//                   <button className="upload-button">
//                     <img
//                       src={upload}
//                       alt="Upload"
//                       className="icon-img"
//                       style={{ width: "15px", height: "15px" }}
//                     />
//                     <span>Upload</span>
//                   </button>
//                 )} */}
//                 <button
//                   className={`preview-button ${!image.url ? "disabled" : ""}`}
//                   onClick={() => image.url && setPreviewUrl(image.url)}
//                   disabled={!image.url}
//                 >
//                   <img
//                     src={image.url ? image.url : preview}
//                     alt="Preview"
//                     className="icon-img"
//                     style={{ width: "15px", height: "15px" }}
//                   />
//                   <span>Preview</span>
//                 </button>

//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Image Preview Modal */}
//       {previewUrl && (
//         <div className="preview-modal" onClick={() => setPreviewUrl(null)}>
//           <div className="preview-content" onClick={(e) => e.stopPropagation()}>
//             <img src={previewUrl} alt="Preview" />
//             <button className="close-btnn" onClick={() => setPreviewUrl(null)}>
//               ❌ Close
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default RepairProcess;
import React, { useState, useEffect } from "react";
import "./postrepairprocess.css";
import { useParams } from "react-router";
import axios from "axios";

const initialImages = [
  { id: 1, name: "Image_1", date: "", url: null },
  { id: 2, name: "Image_2", date: "", url: null },
  { id: 3, name: "Image_3", date: "", url: null },
];

const RepairProcess = () => {
  const { claimNumber } = useParams();
  const [images, setImages] = useState(initialImages);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const upload = `${process.env.PUBLIC_URL}/claim-landing/upload.png`;
  const preview = `${process.env.PUBLIC_URL}/preview.png`;
  const repair = `${process.env.PUBLIC_URL}/repairandpostrepair.png`;

  // ✅ AWS S3: No need for base URL & SAS token (use signed URLs)
  const tryBlobExtensions = async (baseName) => {
    const extensions = ["jpg", "jpeg"];
    for (let ext of extensions) {
      const blobName = `${baseName}.${ext}`;
      try {
        const response = await axios.post("/process_data/check_document_exists", { blobName });
        if (response.data.exists && response.data.url) {
          // ✅ Backend returns signed URL
          return { blobName, url: response.data.url };
        }
      } catch (err) {
        console.error(`Error checking ${blobName}:`, err.message);
      }
    }
    return null;
  };

  useEffect(() => {
    const checkImagesExist = async () => {
      const updatedImages = await Promise.all(
        initialImages.map(async (img) => {
          const baseBlobName = `Pre-repair-images/${claimNumber}_pre_${img.name}`;
          const result = await tryBlobExtensions(baseBlobName);
          if (result) {
            return {
              ...img,
              url: result.url,
              date: new Date().toLocaleString(),
            };
          }
          return img;
        })
      );
      setImages(updatedImages);
    };

    checkImagesExist();
  }, [claimNumber]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = async () => {
      try {
        const base64String = reader.result.split(",")[1];
        const updatedImages = [...images];
        const currentDateTime = new Date().toLocaleString();
        const docId = images[currentImageIndex].name;
        const ext = file.name.split(".").pop();
        const blobName = `Pre-repair-images/${claimNumber}_pre_${docId}.${ext}`;
        const contentType = file.type;

        console.log("Uploading to S3:", { blobName, contentType });

        // ✅ Upload to S3 (backend handles S3 upload & returns signed URL)
        const response = await axios.post("/process_data/upload-file", {
          blobName,
          fileContent: base64String,
          contentType,
        });

        if (response.data.message === "Upload successful") {
          updatedImages[currentImageIndex].url = response.data.url; // ✅ Use signed URL from backend
          updatedImages[currentImageIndex].date = currentDateTime;

          setImages(updatedImages);

          // ✅ Update claim progress in DB
          await axios.post("/process_data/update_pre_repair_upload", { claimNumber });

          if (currentImageIndex < images.length - 1) {
            setCurrentImageIndex(currentImageIndex + 1);
          }
        } else {
          throw new Error("Upload failed at backend.");
        }
      } catch (error) {
        console.error("Upload to backend failed:", error);
        alert("Failed to upload image.");
      }
    };

    reader.readAsDataURL(file);
  };

  return (
    <div>
      {/* Post Repair Section */}
      <div className="post-repair-card">
        <div className="header">
          <h2>Repair Process</h2>
          <img src={repair} alt="Preview" className="icon-img" style={{ width: "24px", height: "24px" }} />
        </div>

        {/* Mobile Camera Upload */}
        <div className="image-box">
          <label className={`camera-label ${!isMobile ? "disabled" : ""}`}>
            <input
              type="file"
              accept="image/*"
              capture="environment"
              style={{ display: "none" }}
              onChange={handleUpload}
              disabled={!isMobile}
            />
            <div className={`camera-trigger ${!isMobile ? "disabled" : ""}`}>
              <img
                src="https://icons.iconarchive.com/icons/iconsmind/outline/512/Camera-2-icon.png"
                alt="camera"
                className="camera-icon"
              />
              <p>Open Camera</p>
            </div>
          </label>
        </div>
      </div>

      {/* Post Repair Images Section */}
      <div className="card">
        <h3 className="title">Repair Process Images</h3>
        <div className="image-list">
          {images.map((image) => (
            <div key={image.id} className="image-card">
              <div className="image-content">
                <div className="text-info">
                  <p className="image-name">{image.name}</p>
                  {image.date && <p className="image-date">{image.date}</p>}
                </div>
                <button
                  className={`preview-button ${!image.url ? "disabled" : ""}`}
                  onClick={() => image.url && setPreviewUrl(image.url)}
                  disabled={!image.url}
                >
                  <img
                    src={image.url ? image.url : preview}
                    alt="Preview"
                    className="icon-img"
                    style={{ width: "15px", height: "15px" }}
                  />
                  <span>Preview</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Preview Modal */}
      {previewUrl && (
        <div className="preview-modal" onClick={() => setPreviewUrl(null)}>
          <div className="preview-content" onClick={(e) => e.stopPropagation()}>
            <img src={previewUrl} alt="Preview" />
            <button className="close-btnn" onClick={() => setPreviewUrl(null)}>❌ Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RepairProcess;
